import { createAction } from '@reduxjs/toolkit';

export default createAction('adjustSaleType', ({ saleType, locationId }) => ({
  payload: {
    saleType,
    locationId,
  },
}));
